function isTrue(data: any): data is true {
	return typeof data === 'boolean' && data === true;
}

function isSelf(data: SelfRule): data is SelfRule {
	return (
		!!data &&
		(typeof data === 'string' ||
			(typeof data === 'object' &&
				(typeof data.self === 'string' ||
					(typeof data.self === 'object' && typeof data.self.db === 'string' && typeof data.self.param === 'string'))))
	);
}

type ListTrue = {
	read: true;
	list: true;
};

type ReadTrue = {
	read: true;
};

type ReadSelf = {
	read: SelfRule;
};

type ListSelf = {
	read: SelfRule;
	list: SelfRule;
};

type Create = {
	create: true;
};

type Edit = {
	update: true;
};

type EditSelf = {
	update: SelfRule;
};

type Full = {
	read: true;
	list: true;
	update: true;
	create: true;
};

function _read(self: false): (data: any) => data is ReadTrue;
function _read(self: true): (data: ReadSelf) => data is ListSelf;
function _read(self: boolean) {
	if (self) {
		return (data: ReadSelf): data is ListSelf => {
			return !!data && isSelf(data.read);
		};
	}
	return (data: any): data is ReadTrue => {
		return !!data && isTrue(data.read);
	};
}
export const read = _read(false);
export const readSelf = _read(true);

function _list(self: false): (data: any) => data is ListTrue;
function _list(self: true): (data: ListSelf) => data is ListSelf;
function _list(self: boolean) {
	if (self) {
		return (data: ListSelf): data is ListSelf => {
			return !!data && isSelf(data.list) && isSelf(data.read);
		};
	}
	return (data: any): data is ListTrue => {
		return !!data && isTrue(data.list) && isTrue(data.read);
	};
}
export const list = _list(false);
export const listSelf = _list(true);

export const create = (data: any): data is Create => {
	return !!data && isTrue(data.create);
};

function _edit(self: false): (data: any) => data is Edit;
function _edit(self: true): (data: EditSelf) => data is EditSelf;
function _edit(self: boolean) {
	if (self) {
		return (data: EditSelf): data is EditSelf => {
			return !!data && isSelf(data.update);
		};
	}
	return (data: any): data is Edit => {
		return !!data && isTrue(data.update);
	};
}
export const edit = _edit(false);
export const editSelf = _edit(true);

export const full = (data: any): data is Full => {
	return !!data && isTrue(data.list) && isTrue(data.read) && isTrue(data.create) && isTrue(data.update);
};

const _rules = {
	// User Profile
	Profile: {
		rules: [
			{
				name: 'Profile',
				validator: read,
			},
			{
				name: 'Profile',
				validator: editSelf,
			},
		],
	},
	UserList: {
		rules: [
			{
				name: 'User',
				validator: list,
			},
		],
	},
	UserReadOnly: {
		rules: [
			{
				name: 'User',
				validator: listSelf,
			},
		],
	},
	UserFull: {
		rules: [
			{
				name: 'User',
				validator: full,
			},
		],
	},
	UserEdit: {
		rules: [
			{
				name: 'User',
				validator: editSelf,
			},
		],
	},
	PlacesFull: {
		rules: [
			{
				name: 'Place',
				validator: full,
			},
		],
	},
	FaqFull: {
		rules: [
			{
				name: 'Faq',
				validator: full,
			},
		],
	},
	AppConfigFull: {
		rules: [
			{
				name: 'AppConfig',
				validator: full,
			},
		],
	},
	NotificationFull: {
		rules: [
			{
				name: 'Notification',
				validator: full,
			},
		],
	},
	ParkingFull: {
		rules: [
			{
				name: 'Vehicle',
				validator: full,
			},
			{
				name: 'Access',
				validator: full,
			},
		],
	},
	InAppFull: {
		rules: [
			{
				name: 'InAppSaleAvailability',
				validator: full,
			},
			{
				name: 'InAppSale',
				validator: edit,
			},
			{
				name: 'Product',
				validator: list,
			},
			{
				name: 'ProductCategory',
				validator: list,
			},
			{
				name: 'Section',
				validator: list,
			},
		],
	},
	ParkingGate: {
		rules: [
			{
				name: 'Access',
				validator: edit,
			},
		],
	},
	PlaceFull: {
		rules: [
			{
				name: 'Place',
				validator: full,
			},
		],
	},
	PlaceEdit: {
		rules: [
			{
				name: 'Place',
				validator: editSelf,
			},
		],
	},
	EventFull: {
		rules: [
			{
				name: 'Event',
				validator: full,
			},
		],
	},
	ArtistFull: {
		rules: [
			{
				name: 'Artist',
				validator: full,
			},
		],
	},

	MerchFull: {
		rules: [
			{
				name: 'Merch',
				validator: full,
			},
			{
				name: 'MerchCategory',
				validator: full,
			},
		],
	},

	BarFull: {
		rules: [
			{
				name: 'Product',
				validator: full,
			},
			{
				name: 'ProductCategory',
				validator: full,
			},
			{
				name: 'Section',
				validator: full,
			},
			{
				name: 'Order',
				validator: list,
			},
		],
	},

	Reports: {
		rules: [
			{
				name: 'Order',
				validator: (data: any): data is ReadTrue => {
					console.debug('=================> data: ', data);
					return true;
				},
			},
		],
	},

	CandidatesFull: {
		rules: [
			{
				name: 'Candidate',
				validator: full,
			},
		],
	},

	AppCommentsFull: {
		rules: [
			{
				// We do not need to control for model
				name: 'User',
				validator: full,
			},
		],
	},

	UserBalanceFull: {
		rules: [
			{
				// We do not need to control for model
				name: 'User',
				validator: read,
			},
			{
				name: 'UserBalace',
				validator: full,
			},
		],
	},

	NfcFull: {
		rules: [
			{
				name: 'NfcCard',
				validator: full,
			},
		],
	},
};

const rules: RulesDictionary = _rules;

export type RuleKey = keyof typeof _rules | '*';

export type RuleKeys = RuleKey | Array<RuleKey>;

export default rules;
